module.exports = __webpack_public_path__ + "static/media/6.b90e7fd8.jpg";